<template>
    <v-row
        no-gutters
        align="center"
    >
        <v-col class="shrink">
            <v-row
                no-gutters
                justify="end"
                class="title"
                style="flex-wrap: nowrap; white-space: nowrap"
            >
                <v-col v-if="count > 0" class="pr-1">
                    {{ count }}
                </v-col>
                <v-col :class="count > 0 ? 'text-lowercase-first-letter' : 'text-uppercase-first-letter'">
                    {{ headerTitle }}
                </v-col>
            </v-row>
        </v-col>
        
        <v-col>
            <v-row
                no-gutters
                align="center"
                class="flex-nowrap"
            >
                <v-col>
                    <slot name="left-button" />
                </v-col>
                <v-col class="shrink">
                    <slot name="right-button" />
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import { computed } from "@vue/composition-api";
import { chooseStringByCount } from '@/helpers/helpers'

export default {
    name: "BillingDialogProductTableToolbar",
    props: {
        textSingular: {
            type: String,
            default: 'Item'
        },
        textPlurar: {
            type: String,
            default: 'Items'
        },
        count: {
            type: Number,
            default: 0
        }
    },
    setup(props, ctx) {

        const headerTitle = computed(() => {
            return chooseStringByCount(props.count, props.textSingular, props.textPlurar)
        })

        return {
            headerTitle,
        };
    }
};
</script>
